import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import { SubmitButton } from 'Elements/Form';

import CustomerBasicInfo from './CustomerBasicInfo';
import CustomerProducts from './CustomerProducts';
import CustomerServices from './CustomerServices';
import CustomerTiresTable from './CustomerTiresTable';
import CustomerUsersTable from './CustomerUsersTable';
import CustomerVehiclesTable from './CustomerVehiclesTable';

const Height100 = styled.div`
  height: 100%;
`;

const ScrollOverflow = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
`;

type Props = {
  title: string;
  subtitle?: string;
};

export default function CustomerPage({ title, subtitle }: Props) {
  return (
    <Grid container direction="column" component={Height100}>
      <AppBar>
        <Toolbar>
          <div>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
          </div>
          <SubmitButton color="secondary" variant="contained">
            Tallenna
          </SubmitButton>
        </Toolbar>
      </AppBar>
      <Grid component={ScrollOverflow} item xs>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomerBasicInfo />
          </Grid>
          <Grid item xs={12}>
            <CustomerTiresTable />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <CustomerUsersTable />
              </Grid>

              <Grid item xs={12}>
                <CustomerVehiclesTable />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomerProducts />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomerServices />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
